import image1 from "../../assets/images/Portfolio/Glass/Balustrada1.jpg";
import image3 from "../../assets/images/Portfolio/Glass/Balustrada2.jpg";
import image4 from "../../assets/images/Portfolio/Glass/Balustrada3.jpg";
import image5 from "../../assets/images/Portfolio/Glass/Balustrada4.jpg";
import image6 from "../../assets/images/Portfolio/Glass/Balustrada5.jpg";
import image7 from "../../assets/images/Portfolio/Glass/Balustrada6.jpg";
import image8 from "../../assets/images/Portfolio/Glass/KabinaPrysznicowa1.jpg";
import image13 from "../../assets/images/Portfolio/Glass/Balustrada7.jpg";

import invest1 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje9.JPG";
import invest2 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje10.JPG";
import invest3 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje3.jpg";
import invest4 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje4.jpg";
import invest5 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje5.jpg";
import invest6 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje6.jpg";
import invest7 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje7.jpg";
import invest8 from "../../assets/images/Portfolio/ConstructionInvestments/Inwestycje8.jpg";

export const GlassGallery = [
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image1,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image3,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image4,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image5,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image6,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image7,
  },
  {
    alt: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    caption: "Balustrada szklana - szkło: VSG ESG 10.10.4",
    src: image13,
  },
  {
    alt: "Kabina prysznicowa - szkło: 8mm ESG Optiwhite",
    caption: "Kabina prysznicowa - szkło: 8mm ESG Optiwhite",
    src: image8,
  },
];

export const ConstructionInvestmentsGallery = [
  {
    alt: "Konstrucja stalowa hali produkcyjnej",
    caption: "Konstrucja stalowa hali produkcyjnej",
    src: invest1,
  },
  {
    alt: "Inwestycja budowlana - zdjęcie 2",
    caption: "Inwestycja budowlana - zdjęcie 2",
    src: invest2,
  },
  {
    alt: "Budynek cynkowni ogniowej",
    caption: "Budynek cynkowni ogniowej",
    src: invest3,
  },
  {
    alt: "Instalacja pieca cynkowniczego",
    caption: "Instalacja pieca cynkowniczego",
    src: invest4,
  },
  {
    alt: "Budynek cynkowni ogniowej",
    caption: "Budynek cynkowni ogniowej",
    src: invest5,
  },
  {
    alt: "Hala produkcyjna drogowych barier energochłonnych",
    caption: "Inwestycja budowlana - zdjęcie 6",
    src: invest6,
  },
  {
    alt: "Instalacja linii technologicznej cynkowni",
    caption: "Instalacja linii technologicznej cynkowni",
    src: invest7,
  },
  {
    alt: "Instalacja linii technologicznej cynkowni",
    caption: "Instalacja linii technologicznej cynkowni",
    src: invest8,
  },
];
